import { combineReducers } from 'redux'
import { Auth, i18n, Preloader, Loader, Firebase, Timer, StoryLine, SavePoint, Game } from './Core'

import mars from './Mars/mars.reducers'

import tutorial from './Tutorial/tutorial.reducer'

export default combineReducers({
  // Here come the reducers of each module
  mars,
  tutorial,
  auth: Auth.reducer,
  game: Game.reducer,
  i18n: i18n.reducer,
  firebase: Firebase.reducer,
  preloader: Preloader.reducer,
  loader: Loader.reducer,
  savePoint: SavePoint.reducer,
  storyLine: StoryLine.reducer,
  timers: Timer.reducer,
})
